import { render, staticRenderFns } from "./AddMedicine.vue?vue&type=template&id=c99bc620&scoped=true"
import script from "./AddMedicine.vue?vue&type=script&lang=js"
export * from "./AddMedicine.vue?vue&type=script&lang=js"
import style0 from "./AddMedicine.vue?vue&type=style&index=0&id=c99bc620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99bc620",
  null
  
)

export default component.exports